import { AlertSeverity, AlertType, IAlertData } from 'fitbeat.models';

export class AlertEntry implements IAlertData {
    public uid: string;
    public resolved: boolean = false;
    public newSinceLastSeen = false;
    public location = 'Waiting area';
    constructor(
        public type: AlertType,
        public severity: AlertSeverity,
        public title: string,
        public message: string,
        public gymName: string,
        public createdAt = new Date(),
        public userId?: string) {
            this.uid = String(Date.now()  + Math.floor((Math.random() * 1000)));
        }
}
